import { Alert, AlertTitle, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    alert: {
        background: theme.palette.tailwind.sky[50],
        borderRadius: ".5rem",
    },
    alertTitle: {
        color: theme.palette.tailwind.sky[700],
        fontWeight: "normal",
    },
}))

type StandardAlertInfoProps = Readonly<{
    title: string
    icon?: boolean
    className?: string
}>

export function StandardAlertInfo({ title, icon, className }: StandardAlertInfoProps) {
    const { classes, cx } = useStyles()

    return (
        <Alert severity="info" icon={icon} className={cx(classes.alert, className)}>
            <AlertTitle className={classes.alertTitle}>
                <Typography variant="body2">{title}</Typography>
            </AlertTitle>
        </Alert>
    )
}
